const $ = jQuery;

let $productFilterHeading   = $( '.product-filter-heading' );
let $productFilterCheckbox  = $( '.product-filter-checkbox' );
let taxonomy                = '';
let $clearFilter            = $( '.clear-filter' );

// Products
function loadProducts( products ) {

    let $productRow = $( '#productRow' );
    let template = $( '#productItem' ).html();
    let compileTemplate = Handlebars.compile( template );
    $productRow.html( compileTemplate( { "products": products }  ) );

}


function buildQueryString( $filterHeading ) {
    let queryString = '';

    $filterHeading.each( function ( k, v ) {
        taxonomy = $( this ).prop( 'id' );
        let terms = JSON.parse( sessionStorage.getItem( taxonomy ) );
        if ( terms !== null ) {
            let termsString = terms.toString();
            if ( termsString.length > 0 ) {
                if ( queryString.length === 0 ) {
                    queryString = '?' + taxonomy + '=' + termsString;
                } else {
                    queryString = queryString + '&' + taxonomy + '=' + termsString;
                }
            }
        }

    });

    return queryString + '&' + queryOrder;
}

function clearCategories( $filterHeading, $filterCheckbox ) {
    $filterHeading.each( function ( k, v ) {
        taxonomy = $( this ).prop( 'id' );
        sessionStorage.removeItem( taxonomy );
        $filterCheckbox.each( function () {
            $( this ).prop( 'checked', false );
        });
    });
}

let $applyFilters = $( '#apply-filters' );
$applyFilters.on( 'click', function( event ) {
    event.preventDefault();
    getPostsByType( 'products', buildQueryString( $productFilterHeading ) )
});


$clearFilter.on( 'click', function( event ) {
    event.preventDefault();
    getPostsByType( 'products', '' );
});


$productFilterCheckbox.change( function() {
    let the_current_element = $( this );
    let taxonomy = the_current_element.data( 'taxonomy' );
    let getSessionStorage = JSON.parse( sessionStorage.getItem( taxonomy ) );
    let this_taxonomy_array = [];
    if ( getSessionStorage !== null && getSessionStorage !== undefined ) {
        this_taxonomy_array = getSessionStorage;
    }

    if ( the_current_element.is( ':checked' ) ) {

        if ( $.inArray( the_current_element.val(), this_taxonomy_array ) === -1 ) {
            this_taxonomy_array.push( the_current_element.val() );
        }
        sessionStorage.setItem( taxonomy, JSON.stringify(  this_taxonomy_array )  );
    } else {
        if ( this_taxonomy_array.length > 0 ) {
            let index = this_taxonomy_array.indexOf( the_current_element.val() );
            if ( index > -1 ) {
                this_taxonomy_array.splice(index, 1);
            }
        }
        sessionStorage.setItem( taxonomy, JSON.stringify(  this_taxonomy_array )  );
    }
});

$( document ).on( 'click', '.taxonomy-button', function( event ) {
    event.preventDefault();

    let taxonomy = $( this ).data( 'taxonomy' );
    let getSessionStorage = JSON.parse( sessionStorage.getItem( taxonomy ) );
    let taxonomyId = $( this ).data( 'taxid' );
    let this_taxonomy_array = [];

    if ( getSessionStorage !== null && getSessionStorage !== undefined ) {
        this_taxonomy_array = getSessionStorage;
    }

    if ( this_taxonomy_array.length > 0 ) {
        let index = this_taxonomy_array.indexOf( String(taxonomyId ) );

        if ( index > -1 ) {
            this_taxonomy_array.splice(index, 1);
            if ( this_taxonomy_array.length > 0 ) {
                sessionStorage.setItem( taxonomy, JSON.stringify(  this_taxonomy_array )  );
            }
        }
    }

    let i = 0;
    let $filterButton = $( '.filter-button' );
    $filterButton.each( function () {
        i++;
    });

    let query = buildQueryString( $productFilterHeading );
    if ( i === 1 ) {
        $clearFilter.remove();
        query = '';
    }

    getPostsByType( 'products', query );

});


/**
 * on init will check to see if there are any parameters set and builds the correct query
 * so site-url.com/products/product-taxonomy-name/term-slug will convert to the proper query and make correct
 * call to the REST API
 */
function initLoad() {

    let query = '';
    let $productGridWrap = $( '#productGridWrap');
    let productFilter = $productGridWrap.data( 'productfilter' );
    let filterType = $productGridWrap.data( 'filtertype' );


    if ( productFilter ) {

        let applicationPanel = $( '#'+filterType ).data( 'thepanel' );

        query = '?'+filterType+'=' + productFilter;
        $( applicationPanel + ' input' ).each( function ( k, v ) {
            if ( Number( $( this ).val() ) === productFilter ) {
                $( this ).prop('checked', true );
            }
        });

        addUIElements()
    }

    getPostsByType( 'products', query )
}

// on init
clearCategories( $productFilterHeading, $productFilterCheckbox )
initLoad()